import React from 'react';
import ReactModal from 'react-modal';

const OfficerModal = ({
  isOpen,
  onClose,
  staffList,
  officerList,
  setOfficerList,
  saveOfficerList
}) => {
  const isOfficer = (staff) => officerList.some(o => o.id === staff.id);

  const handleAddOfficer = (staff) => {
    if (!isOfficer(staff)) {
      setOfficerList(prev => [...prev, staff]);
    }
  };

  const handleRemoveOfficer = (staff) => {
    setOfficerList(prev => prev.filter(o => o.id !== staff.id));
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      className="transition-all duration-300 transform bg-white rounded-lg p-6 w-[90%] max-w-4xl mx-auto mt-20 shadow-xl z-60 sm:w-[90%]"
      overlayClassName="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 overflow-auto"
    >
      <h2 className="text-2xl font-bold text-center mb-4 text-teal-700">🧑‍💼 調整幹部名單</h2>

      <div className="grid grid-cols-2 gap-4">
        {/* 左側：人員清單 */}
        <div>
          <h3 className="font-semibold text-center mb-2 text-gray-700">所有人員</h3>
          <ul className="border border-teal-200 rounded p-2 min-h-[350px] max-h-[350px] overflow-auto bg-gray-50">
            {staffList.map((s) => (
              <li
                key={s.id}
                className="p-2 m-1 bg-white rounded shadow flex justify-between items-center"
              >
                {s.name}
                <button
                  onClick={() => handleAddOfficer(s)}
                  disabled={isOfficer(s)}
                  className={`px-2 py-1 text-sm rounded ${
                    isOfficer(s)
                      ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      : 'bg-teal-500 text-white hover:bg-teal-600'
                  }`}
                >
                  加入
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* 右側：幹部名單 */}
        <div>
          <h3 className="font-semibold text-center mb-2 text-gray-700">幹部名單</h3>
          <ul className="border border-teal-200 rounded p-2 min-h-[350px] max-h-[350px] overflow-auto bg-gray-50">
            {officerList.map((s) => (
              <li
                key={s.id}
                className="p-2 m-1 bg-white rounded shadow flex justify-between items-center hover:bg-red-50"
              >
                {s.name}
                <button
                  onClick={() => handleRemoveOfficer(s)}
                  className="px-2 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
                >
                  移除
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

<div className="text-center mt-4 flex justify-center gap-4">
  <button
    onClick={saveOfficerList}
    className="px-6 py-2 bg-teal-600 text-white font-semibold rounded-full shadow hover:bg-teal-700"
  >
    儲存變更
  </button>
  <button
    onClick={onClose}
    className="px-6 py-2 bg-gray-400 text-white font-semibold rounded-full shadow hover:bg-gray-500"
  >
    關閉
  </button>
</div>

    </ReactModal>
  );
};

export default OfficerModal;
